module.exports = __webpack_public_path__ + "img/840.b60d2a6a.svg";